import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { TfiSave } from 'react-icons/tfi';

import { PutUserRequest } from 'api/users/types';

import { Field } from 'components/ui/Field';
import { useAuthStore } from 'store/auth';
import { userSchema } from 'utils/yup';
import { putMe } from 'api/users';

const AccountSettings = () => {
  const { user, setUser } = useAuthStore();
  const { mutate, isLoading } = useMutation(putMe);

  const initialValues: PutUserRequest = {
    name: user?.name || '',
    email: user?.email || '',
    oldPassword: '',
    newPassword: '',
    repeatPassword: ''
  };

  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    onSubmit: (values, { setErrors }) => {
      mutate(values, {
        onSuccess: (newUser) => setUser(newUser),
        onError: (error: any) => setErrors({ oldPassword: error.data.message })
      });
    }
  });

  return (
    <div className="p-6">
      <div className="paper p-4">
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-6">
          <p className="font-semibold">General Info</p>
          <div className="grid items-start grid-cols-1 lg:grid-cols-2 gap-6">
            <Field label="Full Name" formik={formik} name="name" />
          </div>
          <Field label="Email Address" formik={formik} name="email" type="email" />
          <p className="font-semibold">Reset Password</p>
          <Field label="Old Password" formik={formik} name="oldPassword" type="password" />
          <Field label="New Password" formik={formik} name="newPassword" type="password" />
          <Field label="Confirm New Password" formik={formik} name="repeatPassword" type="password" />
          <button type="submit" className="secondaryBtn w-fit mt-6" disabled={isLoading}>
            <TfiSave />
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccountSettings;
